export default {
  MISSING_ALIGNER: 'MISSING_ALIGNER',
  BROKEN_ALIGNER: 'BROKEN_ALIGNER',
  IRRIGATION_TO_GUM: 'IRRIGATION_TO_GUM',
  SHARP_EDGES: 'SHARP_EDGES ',
} as const
